import React from "react";

export default function DarkModeButton({
  children,
  label = "",
  onClick,
  style,
  innerStyle,
  className,
}) {
  return (
    <div style={style} className={className}>
      <div className="cta-button-main" onClick={onClick}>
        <div className="cta-button-inner" style={{ ...innerStyle }}>
          {children != null ? children : label}
        </div>
      </div>
    </div>
  );
}
